import '@/common/utils/datetime-init'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import vuetify from '@/common/theme/vuetify'
import { useApi } from '@/common/state/stores/apiStore'
import { useAuthStore } from '@/common/state/stores/authStore'
import router from '@/web/router'
import { getApiBaseUrl, getToken } from '@/web/services/webApi'
import WebApp from '@/web/WebApp.vue'
import '@/common/styles/index.css'
import '@/web/styles/web.css'

async function bootstrapWebAuth() {
  const apiBaseUrl = getApiBaseUrl()
  const useDevApi = apiBaseUrl.includes('127.0.0.1') || apiBaseUrl.includes('localhost')
  useApi().setEnvironment(useDevApi ? 'development' : 'production')

  const token = getToken()
  if (!token) {
    return
  }

  useApi().setAccessToken(token)
  await useAuthStore().login(token)

  try {
    await useAuthStore().refreshCurrentUser()
  } catch {
    // Keep session alive with cached auth token if user refresh fails.
  }
}

const app = createApp(WebApp)
const pinia = createPinia()
app.use(pinia).use(vuetify).use(router)

bootstrapWebAuth().finally(() => {
  app.mount('#app')
})
